const parametersFields = vm => [
  {
    key: 'description',
    sortable: false,
    label: vm.$t('fields.engineering.cooling-maintenance.description'),
    class: 'cooling-maintenance-parameters-tab__description',
  },
  {
    key: 'operatingTimeMaintenance',
    sortable: false,
    label: vm.$t('fields.engineering.cooling-maintenance.operating-time-maintenance'),
    class: 'cooling-maintenance-parameters-tab__operating-time-maintenance',
  },
  {
    key: 'advanceNoticeMaintenance',
    sortable: false,
    label: vm.$t('fields.engineering.cooling-maintenance.advance-notice-maintenance'),
    class: 'cooling-maintenance-parameters-tab__advance-notice-maintenance',
  },
  {
    key: 'associatedContact',
    sortable: false,
    label: vm.$t('fields.engineering.cooling-maintenance.associated-contact'),
    class: 'cooling-maintenance-parameters-tab__associated-contact',
  },
  {
    key: 'actions',
    sortable: false,
    label: '',
  },
];

export default parametersFields;
